<template>
  <el-dialog
    :title="gameData ? '编辑游戏' : '新增游戏'"
    :visible="isVisible"
    :close-on-click-modal="false"
    class="page-dialog center-dialog"
    width="480px"
    @closed="handleDialogClosed"
    @close="handleCancel"
  >
    <el-form ref="gameFormRef" :model="formData" :rules="formRules" label-width="80px" size="small">
      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="游戏名称" prop="title">
            <el-input v-model="formData.title" placeholder="请输入游戏名称" size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="游戏编号" prop="game_id">
            <el-input v-model="formData.game_id" placeholder="请输入游戏编号" size="small"></el-input>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-form-item label="排序" prop="sort">
        <el-input-number v-model="formData.sort" :controls="false" :min="1" :step="1" placeholder="请输入排序" size="small"></el-input-number>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12"> </el-col>
        <!-- <el-col :span="12">
          <el-form-item label="游戏品牌" prop="category">
            <el-select v-model="formData.category" placeholder="请选择游戏品牌" size="small">
              <el-option label="品牌1" value="brand1"></el-option>
              <el-option label="品牌2" value="brand2"></el-option>
              <el-option label="品牌3" value="brand3"></el-option>
            </el-select>
          </el-form-item>
        </el-col> -->
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="厂商" prop="vendor_code">
            <el-select v-model="formData.vendor_code" placeholder="请选择厂商" size="small">
              <el-option label="realpg" value="realpg"></el-option>
              <el-option label="mg" value="mg"></el-option>
              <el-option label="ag" value="ag"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="游戏类型" prop="game_type">
            <el-select v-model="formData.game_type" placeholder="请选择游戏类型" size="small">
              <el-option label="电子" value="电子"></el-option>
              <el-option label="真人" value="真人"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row> -->
      <el-form-item label="游戏标签" prop="tags">
        <el-select v-model="formData.tags" style="width: 100%" multiple placeholder="请选择游戏标签" size="small">
          <el-option v-for="item in tagsList" :key="item.id" :label="item.title" :value="item.title">
            <span style="margin-right: 10px">{{ item.title }}</span>
            <el-tag type="success" size="small">{{ item.status === 1 ? '启用' : '禁用' }}</el-tag>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="formData.status" size="small">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="2">禁用</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-row :gutter="20">
        <el-col :span="12"> </el-col>
        <el-col :span="12"> </el-col>
      </el-row>

      <!-- <el-row>
        <el-col :span="24">
          <el-form-item label="游戏图片">
            <el-upload class="avatar-uploader" action="#" :show-file-list="false" :on-change="handleImageChange" :before-upload="beforeUpload" :auto-upload="false">
              <el-image v-if="formData.image_url" :src="formData.image_url" fit="cover" style="width: 120px; height: 120px; border-radius: 4px; cursor: pointer"></el-image>
              <div
                v-else
                class="el-upload__placeholder"
                style="width: 120px; height: 120px; border: 1px dashed #d9d9d9; border-radius: 4px; display: flex; align-items: center; justify-content: center; cursor: pointer"
              >
                <i class="el-icon-plus"></i>
                <span style="margin-left: 8px">点击上传</span>
              </div>
            </el-upload>
            <div style="margin-top: 8px; font-size: 12px; color: #999">支持 jpg、jpeg、png、webp 格式，大小不超过 2M</div>
          </el-form-item>
        </el-col>
      </el-row> -->
    </el-form>

    <template slot="footer">
      <el-button size="small" @click="handleCancel">取消</el-button>
      <el-button type="primary" size="small" :loading="loading" @click="handleConfirm">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { createGameItem, updateGameItem } from '@/api/gameManage/gameList.js'
import { listGameCategory } from '@/api/gameManage/gameTag.js'
import { uploadToS3 } from '@/api/upload.js'

export default {
  name: 'ManageGameDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    gameData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        title: '',
        game_id: '',
        sort: 1,
        category: '',
        vendor_code: '',
        game_type: '',
        tags: [],
        status: 1,
        image_url: '',
      },
      formRules: {
        title: [{ required: true, message: '请输入游戏名称', trigger: 'blur' }],
        game_id: [{ required: true, message: '请输入游戏编号', trigger: 'blur' }],
        sort: [
          { required: true, message: '请输入排序', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字', trigger: 'blur' },
        ],
        category: [{ required: true, message: '请选择游戏品牌', trigger: 'change' }],
        vendor_code: [{ required: true, message: '请选择厂商', trigger: 'change' }],
        game_type: [{ required: true, message: '请选择游戏类型', trigger: 'change' }],
        // tags: [{ required: true, message: '请选择游戏标签', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      loading: false,
      tagsList: [],
    }
  },
  watch: {
    gameData: {
      handler(newVal) {
        if (newVal) {
          this.formData = { ...newVal }
          // 确保状态是数字类型
          this.formData.status = Number(this.formData.status)
        } else {
          this.resetForm()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.getTagsList()
  },
  methods: {
    handleDialogClosed() {
      this.resetForm()
    },

    async getTagsList() {
      console.log('getTagsList')
      try {
        const response = await listGameCategory({
          page: 1,
          page_size: 100,
        })
        if (response.code === 0) {
          this.tagsList = response.data.list
        }
      } catch (error) {
        console.error('获取游戏标签列表失败:', error)
      }
    },

    resetForm() {
      this.formData = {
        title: '',
        game_id: '',
        sort: 1,
        category: '',
        vendor_code: '',
        game_type: '',
        tags: [],
        status: 1,
        image_url: '',
      }
      if (this.$refs.gameFormRef) {
        this.$refs.gameFormRef.resetFields()
      }
      this.loading = false
    },

    handleCancel() {
      this.$emit('close')
    },

    async handleImageChange(file) {
      try {
        const result = await uploadToS3(file.raw)
        if (result.success) {
          this.formData.image_url = result.data.objectUrl
          this.$message.success('图片上传成功')
        } else {
          this.$message.error('图片上传失败：' + result.error)
        }
      } catch (error) {
        this.$message.error('图片上传失败：' + error.message)
        console.error('图片上传失败:', error)
      }
    },

    beforeUpload(file) {
      const isJPG = /\.(jpg|jpeg|png|webp)$/i.test(file.name)
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('只能上传 JPG、JPEG、PNG、WEBP 格式的图片')
        return false
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB')
        return false
      }

      return true
    },

    async handleConfirm() {
      try {
        await this.$refs.gameFormRef.validate()
        this.loading = true

        const formData = { ...this.formData }

        if (this.gameData) {
          // 编辑操作
          const realFormData = {
            game_id: formData.game_id,
            sort: formData.sort,
            status: formData.status,
            tags: Array.isArray(formData.tags) ? formData.tags : [formData.tags],
          }
          const response = await updateGameItem(realFormData)
          if (response.code === 0) {
            this.$message.success('编辑游戏成功')
            this.$emit('save-success')
            this.$emit('close')
          } else {
            this.$message.error('编辑游戏失败：' + (response.msg || '未知错误'))
          }
        } else {
          // 新增操作
          const response = await createGameItem(formData)
          if (response.code === 0) {
            this.$message.success('新增游戏成功')
            this.$emit('save-success')
            this.$emit('close')
          } else {
            this.$message.error('新增游戏失败：' + (response.msg || '未知错误'))
          }
        }
      } catch (error) {
        if (error !== 'validate') {
          // this.$message.error('操作失败：' + error.message)
          console.error('操作失败:', error)
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.avatar-uploader {
  margin-bottom: 16px;
}
</style>
